module.exports = __webpack_public_path__ + "img/teasers_3.861914bf.jpg";